import { createAction } from 'redux-actions';

export const LoginRequest = createAction('LOGIN_REQUEST');
export const LoginSuccess = createAction('LOGIN_SUCCESS');
export const LoginFailed = createAction('LOGIN_FAILED');
export const LoginClear = createAction('LOGIN_CLEAR');

export const RefreshTokenRequest = createAction('REFRESH_TOKEN_REQUEST');
export const RefreshTokenSuccess = createAction('REFRESH_TOKEN_SUCCESS');
